import { render, staticRenderFns } from "./createOutsource.vue?vue&type=template&id=3477f3b7&"
import script from "./createOutsource.vue?vue&type=script&lang=js&"
export * from "./createOutsource.vue?vue&type=script&lang=js&"
import style0 from "./createOutsource.vue?vue&type=style&index=0&id=3477f3b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports